import React, { useState } from 'react';
import './ProjectImageScroll.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';

const ProjectImageScroll = ({ data = [], title, detail }) => {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [transformOrigin, setTransformOrigin] = useState('center center');

  const openSlider = (index) => {
    setCurrentImageIndex(index);
    setIsSliderOpen(true);
  };

  const closeSlider = () => {
    setIsSliderOpen(false);
    setIsZoomed(false);
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % data.length);
    setIsZoomed(false);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
    setIsZoomed(false);
  };

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  const handleMouseMove = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setTransformOrigin(`${x}% ${y}%`);
  };

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className='ProjectImage-Container'>
      <h1 className='ProjectImage-title1'>{title}</h1>
      <h2 className='ProjectImage-title2'>{detail}</h2>

      <div className='ProjectImage-PhotosCard'>
        {data.slice(0, 2).map((image, index) => (
          <img
            key={index}
            src={image.url}
            alt={`Image ${index + 1}`}
            className='ProjectImage-thumbnail'
            onClick={() => openSlider(index)}
          />
        ))}
      </div>

      {isSliderOpen && (
        <div className='ProjectImage-slider'>
          <FontAwesomeIcon icon={faTimes} className='slider-close' onClick={closeSlider} />
          <img
            src={data[currentImageIndex]?.url}
            alt={`Image ${currentImageIndex + 1}`}
            className={`slider-image ${isZoomed ? 'zoomed' : ''}`}
            onClick={toggleZoom}
            onMouseMove={handleMouseMove}
            style={{ transformOrigin }}
          />
          <div className='slider-navigation'>
            <FontAwesomeIcon icon={faChevronLeft} className='slider-icon left' onClick={handlePrev} />
            <FontAwesomeIcon icon={faChevronRight} className='slider-icon right' onClick={handleNext} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectImageScroll;
